module.exports = {
    start_datetime: "",
    end_datetime: "",
    contact_email: "info@greengenvyrnwyfrankton.com",
    telephone: "0800 915 3590",

    // Consultation close countdown. If set to true, show countdown in site header
    has_countdown: false,
    countdown_end: "00/00/0000 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

    closed_message: "This consultation is closed and is no longer accepting feedback.",
    form_url: {
        en: "/en/consultation/feedback-form/about-you",
        cy: "/cy/consultation/feedback-form/about-you"
    },
    review_url: {
        en: "/en/consultation/feedback-form/review/",
        cy: "/cy/consultation/feedback-form/review/"
    },
    success_url: {
        en: "/en/consultation/feedback-form/success/",
        cy: "/cy/consultation/feedback-form/success/"
    },

    // This value needs to match the slug of the contact section. Determines which fields to show
    contact_slug: "about-you",

    sections: [
        {
            name: {
                en: "About you",
                cy: "Gwybodaeth amdanoch chi"
            },
            slug: "about-you",
            icon: "",
            colour: "section-6",
            intro: "",
            questions: [
                {
                    label: {
                        en: "Title:",
                        cy: "Teitl:"
                    },
                    name: "title",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "Enter your title",
                        cy: "Rhowch eich teitl"
                    }
                },
                {
                    label: {
                        en: "First name:",
                        cy: "First Enw:"
                    },
                    name: "first_name",
                    required: true,
                    type: "text",
                    placeholder: {
                        en: "Enter your first name",
                        cy: "Rhowch eich enw cyntaf"
                    }
                },
                {
                    label: {
                        en: "Surname:",
                        cy: "Sur Enw:"
                    },
                    name: "last_name",
                    required: true,
                    type: "text",
                    placeholder: {
                        en: "Enter your surname",
                        cy: "Rhowch eich cyfenw"
                    }
                },
                {
                    label: {
                        en: "Age group:",
                        cy: "Grŵp oedran:"
                    },
                    name: "age_group",
                    required: false,
                    type: "radio",
                    multiple: false, // Not required, for visual use only
                    options: [
                        {
                            label: {
                                en: "18 and under",
                                cy: "Dan 18"
                            },
                            value: "18-under"
                        },
                        {
                            label: {
                                en: "19-34",
                                cy: "19-34"
                            },
                            value: "19-34"
                        },
                        {
                            label: {
                                en: "35-50",
                                cy: "35-50"
                            },
                            value: "35-50"
                        },
                        {
                            label: {
                                en: "51-65",
                                cy: "51-65"
                            },
                            value: "51-65"
                        },
                        {
                            label: {
                                en: "Over 65",
                                cy: "Dros 65 oed"
                            },
                            value: "over-65"
                        }
                    ]
                },
                {
                    label: {
                        en: "Address:",
                        cy: "Cyfeiriad:"
                    },
                    name: "address",
                    required: true,
                    type: "text",
                    placeholder: {
                        en: "Enter your address",
                        cy: "Rhowch eich cyfeiriad"
                    }
                },
                {
                    label: {
                        en: "Postcode:",
                        cy: "Cod Post:"
                    },
                    name: "postcode",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "Enter your postcode",
                        cy: "Rhowch eich cod post"
                    }
                },
                {
                    label: {
                        en: "Email address:",
                        cy: "Cyfeiriad e-bost:"
                    },
                    name: "email",
                    required: true,
                    type: "email",
                    placeholder: {
                        en: "Enter your email",
                        cy: "Rhowch eich ebost"
                    }
                },
                {
                    label: {
                        en: "Would you like to receive email updates about the project?",
                        cy: "Ydych chi eisiau derbyn diweddariadau e-bost am y prosiect?"
                    },
                    name: "progress",
                    required: false,
                    type: "radio",
                    options: [
                        {
                            label: {
                                en: "Yes",
                                cy: "Ydw"
                            },
                            value: "yes"
                        },
                        {
                            label: {
                                en: "No",
                                cy: "Nac ydw"
                            },
                            value: "no"
                        }
                    ]
                },
                {
                    label: {
                        en: "Are you responding on behalf of an organisation?",
                        cy: "Ydych chi’n ymateb ar ran sefydliad?"
                    },
                    name: "organisation_confirm",
                    required: false,
                    type: "radio",
                    multiple: false, // Not required, for visual use only
                    options: [
                        {
                            label: {
                                en: "Yes",
                                cy: "Ydw"
                            },
                            value: "yes"
                        },
                        {
                            label: {
                                en: "No",
                                cy: "Nac ydw"
                            },
                            value: "no"
                        }
                    ]
                },
                {
                    label: {
                        en: "If yes, which organisation:",
                        cy: "Os ydych chi, pa sefydliad:"
                    },
                    name: "organisation",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "Enter name of organisation",
                        cy: "Rhowch enw eich sefydliad"
                    }
                },
                {
                    label: {
                        en: "Do you own or occupy land within the project boundary?",
                        cy: "Ydych chi’n berchen ar dir neu’n meddiannu tir o fewn ffin y prosiect?"
                    },
                    name: "occupy_land",
                    required: false,
                    type: "radio",
                    multiple: false, // Not required, for visual use only
                    options: [
                        {
                            label: {
                                en: "Yes",
                                cy: "Ydw"
                            },
                            value: "yes"
                        },
                        {
                            label: {
                                en: "No",
                                cy: "Nac ydw"
                            },
                            value: "no"
                        }
                    ]
                },
                {
                    label: {
                        en: "If yes, have you been contacted by our lands team?",
                        cy: "Os ydych chi, a yw ein tîm tiroedd wedi cysylltu â chi?"
                    },
                    name: "occupy_land_yes",
                    required: false,
                    type: "radio",
                    multiple: false, // Not required, for visual use only
                    options: [
                        {
                            label: {
                                en: "Yes",
                                cy: "Ydw"
                            },
                            value: "yes"
                        },
                        {
                            label: {
                                en: "No",
                                cy: "Nac ydw"
                            },
                            value: "no"
                        }
                    ]
                },
                {
                    label: {
                        en: "If you have not been contacted by us, please provide the details of this land, including the address, if different to the above, so we can contact you.",
                        cy: "Os nad ydym wedi cysylltu â chi, rhowch fanylion y tir hwn, gan gynnwys y cyfeiriad, os yw’n wahanol i’r uchod, er mwyn i ni allu cysylltu â chi."
                    },
                    name: "occupy_land_contact",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "",
                        cy: ""
                    }
                }
            ]
        },
        {
            name: {
                en: "Section 1: Cefn Coch to Llangyniew",
                cy: "Adran 1: Cefn Coch i Langyniew"
            },
            slug: "section-1",
            icon: "",
            colour: "section-1",
            intro: "",
            questions: [
                {
                    label: {
                        en: "Are there any specific factors we should consider when reviewing and developing our proposals for this section of the route?",
                        cy: "A oes unrhyw ffactorau penodol y dylem eu hystyried wrth adolygu a datblygu ein cynigion ar gyfer y rhan hon o’r llwybr?"
                    },
                    name: "1-question",
                    number: "1",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "",
                        cy: ""
                    }
                }
            ]
        },
        {
            name: {
                en: "Section 2: Llangyniew to Meifod",
                cy: "Adran 2: Llangyniew i Feifod"
            },
            slug: "section-2",
            icon: "",
            colour: "section-2",
            intro: "",
            questions: [
                {
                    label: {
                        en: "Are there any specific factors we should consider when reviewing and developing our proposals for this section of the route?",
                        cy: "A oes unrhyw ffactorau penodol y dylem eu hystyried wrth adolygu a datblygu ein cynigion ar gyfer y rhan hon o’r llwybr?"
                    },
                    name: "2-question",
                    number: "2",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "",
                        cy: ""
                    }
                }
            ]
        },
        {
            name: {
                en: "Section 3: Meifod to Llansantffraid-ym-Mechian",
                cy: "Adran 3: Meifod i Llansantffraid-ym-Mechian"
            },
            slug: "section-3",
            icon: "",
            colour: "section-3",
            intro: "",
            questions: [
                {
                    label: {
                        en: "Are there any specific factors we should consider when reviewing and developing our proposals for this section of the route?",
                        cy: "A oes unrhyw ffactorau penodol y dylem eu hystyried wrth adolygu a datblygu ein cynigion ar gyfer y rhan hon o’r llwybr?"
                    },
                    name: "3-question",
                    number: "3",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "",
                        cy: ""
                    }
                }
            ]
        },
        {
            name: {
                en: "Section 4: Llansantffraid-ym-Mechian to Llanymynech",
                cy: "Adran 4: Llansantffraid-ym-Mechian i Lanymynech"
            },
            slug: "section-4",
            icon: "",
            colour: "section-4",
            intro: "",
            questions: [
                {
                    label: {
                        en: "Are there any specific factors we should consider when reviewing and developing our proposals for this section of the route?",
                        cy: "A oes unrhyw ffactorau penodol y dylem eu hystyried wrth adolygu a datblygu ein cynigion ar gyfer y rhan hon o’r llwybr?"
                    },
                    name: "4-question",
                    number: "4",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "",
                        cy: ""
                    }
                }
            ]
        },
        {
            name: {
                en: "Section 5: Llanymynech to Lower Frankton",
                cy: "Adran 5: Llanymynech i Lower Frankton"
            },
            slug: "section-5",
            icon: "",
            colour: "section-5",
            intro: "",
            questions: [
                {
                    label: {
                        en: "Are there any specific factors we should consider when reviewing and developing our proposals for this section of the route?",
                        cy: "A oes unrhyw ffactorau penodol y dylem eu hystyried wrth adolygu a datblygu ein cynigion ar gyfer y rhan hon o’r llwybr?"
                    },
                    name: "5-question",
                    number: "5",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "",
                        cy: ""
                    }
                }
            ]
        },
        {
            name: {
                en: "Your comments on our proposals",
                cy: "Eich sylwadau ar ein cynigion"
            },
            slug: "section-6",
            icon: "",
            colour: "section-6",
            intro: "",
            questions: [
                {
                    label: {
                        en: "Is there any information or impacts we should consider when reviewing and developing our proposals? Please provide as much detail as you can.",
                        cy: "A oes unrhyw wybodaeth neu effeithiau y dylem eu hystyried wrth adolygu a datblygu ein cynigion? Rhowch gymaint o fanylion ag y gallwch chi."
                    },
                    name: "6-question",
                    number: "6",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "",
                        cy: ""
                    }
                },
                {
                    label: {
                        en: "Do you have any additional feedback on our proposals that you have not included above?",
                        cy: "A oes gennych chi unrhyw adborth ychwanegol ar ein cynigion nad ydych wedi’u cynnwys gyferbyn?"
                    },
                    name: "7-question",
                    number: "7",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "",
                        cy: ""
                    }
                },
                {
                    label: {
                        en: "How did you hear about the consultation? (tick as appropriate)",
                        cy: "Sut gwnaethoch chi glywed am yr ymgynghoriad? (ticiwch fel bo’n briodol)"
                    },
                    name: "8-question",
                    number: "8",
                    required: false,
                    type: "checkbox",
                    multiple: false, // Not required, for visual use only
                    options: [
                        {
                            label: {
                                en: "Postal information",
                                cy: "Gwybodaeth yn y post"
                            },
                            value: "postal-information"
                        },
                        {
                            label: {
                                en: "News or media coverage",
                                cy: "Newyddion neu sylw yn y cyfryngau"
                            },
                            value: "news-media"
                        },
                        {
                            label: {
                                en: "Social media",
                                cy: "Cyfryngau cymdeithasol"
                            },
                            value: "social-media"
                        },
                        {
                            label: {
                                en: "Notified by someone else",
                                cy: "Wedi clywed gan rywun arall"
                            },
                            value: "someone-else"
                        },
                        {
                            label: {
                                en: "Local information point",
                                cy: "Man gwybodaeth leol"
                            },
                            value: "information-point"
                        },
                        {
                            label: {
                                en: "Other (please provide details)",
                                cy: "Arall (rhowch fanylion)"
                            },
                            value: "other"
                        }
                    ],
                    additional_questions: [
                        {
                            label: {
                                en: "Please provide details",
                                cy: "Rhowch fanylion",
                            },
                            type: "text",
                            name: "8-1-question",
                            number: "1",
                            placeholder: {
                                en: "",
                                cy: ""
                            }
                        },
                    ]
                },
                {
                    label: {
                        en: "Do you have any comments about your experience of the consultation?",
                        cy: "A oes gennych chi unrhyw sylwadau am eich profiad o’r ymgynghoriad?"
                    },
                    name: "9-question",
                    number: "9",
                    required: false,
                    type: "text",
                    placeholder: {
                        en: "",
                        cy: ""
                    }
                }
            ]
        }
    ]
};
